module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_164_HDR-removebg-preview-57001543559d815e06cf56428e2eafee.png";